import Auth from './auth';
import Dashboard from './dashboard';

const RedirectAdminRoute = { path: '/admin', redirect: { name: 'AdminLogin' } };

const routes = [
    ...Auth,
    ...Dashboard,
    RedirectAdminRoute
];

export default routes;